import {Model} from "./base/Model";
import moment from 'moment';

    export class CalenderEvent extends Model  {
        key: string = "";
        dossierKey: string = "";
        name: string;
        description: string = "";
        start_at: number;
        end_at: number;
        timeState: number;
        nextActions: object = {};
        private cast: object = {start_at: 'datetime', end_at: 'datetime' }
        
        constructor(data = null) {
            super(data);
            if(data) {
                this.createModel(data);
            }
        }      
      
        public setData=(data) => {
            let self = this;
            Object.keys(self).forEach( function( keyName, $index){
              self[keyName] = data[keyName];
                });
            //this.createModel(data);
        }      
        
        public getStartDate= (format:string = null) => {
            let retVal = null;
            if(this.start_at && this.start_at > 0) {
                retVal = moment(this.start_at);
                if(format) {
                retVal = retVal.format(format);
                }
            }
            
            return retVal;
        }
        
        public getEndDate= (format:string = null) => {
            let retVal = null;
            if(this.end_at && this.end_at > 0) {
                retVal = moment(this.end_at);
                if(format) {
                    retVal = retVal.format(format);
                }
            }
            
            return retVal;
        } 
        
        public getStartFrom = (datetime = null) => {
            if(!datetime) {
                datetime = moment();
            }
            return  moment.duration(this.getStartDate().diff(datetime));
            
        }
        
        public getEndFrom = (datetime = null) => {
            if(!datetime) {
                datetime = moment();
            }
            return  moment.duration(this.getEndDate().diff(datetime));
        }    
        
        public getState = () => {
            let retVal = 0;
            if( this.getStartFrom().as('milliseconds') < 0 ) {
                if(this.getEndFrom().as('milliseconds') < 0 ) {
                    retVal = 9;
                }
            } else {
                
            }
            
            return retVal;
        }       
    }